import { Routes } from '@angular/router';
import { AuthGuardService } from './guards/authGuardService';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    //  canActivate: [AuthGuardService],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'business/:id',
    loadComponent: () =>
      import('./pages/business/business-detail/business.page').then(
        (m) => m.BusinessPage
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'business-listing',
    loadComponent: () =>
      import('./pages/business/business-listing/business-listing.page').then(
        (m) => m.BusinessListingPage
      ),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: 'coupon',
  //   loadComponent: () => import('./pages/coupon/coupon-detail/coupon-detail.page').then( m => m.CouponDetailPage)
  // },
  {
    path: 'coupon',
    loadComponent: () =>
      import('./pages/coupon/coupon-listing/coupon.page').then(
        (m) => m.CouponPage
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/coupon', key: 'list' },
  },
  {
    path: 'coupon-detail/:id',
    loadComponent: () =>
      import('./pages/coupon/coupon-detail/coupon-detail.page').then(
        (m) => m.CouponDetailPage
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/coupon' },
  },
  {
    path: 'gps',
    loadComponent: () =>
      import('./pages/gps/gps-listing/gps.page').then((m) => m.GpsPage),
    canActivate: [AuthGuardService],
    data: { ns: '/gps' }, 
  },
  {
    path: 'gps-detail/:id',
    loadComponent: () =>
      import('./pages/gps/gps-detail/gps-detail.page').then(
        (m) => m.GpsDetailPage
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/gps' }, 
  },

  {
    path: 'banner',
    loadComponent: () =>
      import('./pages/banner/banner-listing/banner.page').then(
        (m) => m.BannerPage
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/banner' },
  },
  {
    path: 'banner-detail/:id',
    loadComponent: () =>
      import('./pages/banner/banner-detail/banner-detail.page').then(
        (m) => m.BannerDetailPage
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/banner' },
  },
  {
    path: 'customer',
    loadComponent: () =>
      import('./pages/customer/customer-listing/customer.page').then(
        (m) => m.CustomerPage
      ),
  },
  {
    path: 'customer-detail/:id',
    loadComponent: () =>
      import('./pages/customer/customer-detail/customer-detail.page').then(
        (m) => m.CustomerDetailPage
      ),
  },
  {
    path: 'category',
    loadComponent: () =>
      import('./pages/category/category-listing/category-listing.page').then(
        (m) => m.CategoryListingPage
      ),
  },
  {
    path: 'advertisement',
    loadComponent: () =>
      import(
        './pages/advertisement/advertisement-listing/advertisement-listing.page'
      ).then((m) => m.AdvertisementListingPage),
  },
  {
    path: 'category-detail/:id',
    loadComponent: () =>
      import('./pages/category/category-detail/category-detail.page').then(
        (m) => m.CategoryDetailPage
      ),
  },
  {
    path: 'membership',
    loadComponent: () =>
      import('./pages/membership/membership-listing/membership.page').then(
        (m) => m.MembershipListingPage
      ),
  },
  {
    path: 'membership-detail/:id',
    loadComponent: () =>
      import(
        './pages/membership/membership-detail/membership-detail.page'
      ).then((m) => m.MembershipDetailPage),
  },
  {
    path: 'campaign',
    loadComponent: () =>
      import('./pages/Campaign/campaign-listing/campaign.page').then(
        (m) => m.CampaignListingPage
      ),

    canActivate: [AuthGuardService],
    data: { ns: '/campaign' },
  },
  {
    path: 'campaign-detail/:id',
    loadComponent: () =>
      import('./pages/Campaign/campagin-detail/campagin-detail.page').then(
        (m) => m.CampaignDetailPage
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/campaign' },
  },

  {
    path: 'wallet',
    loadComponent: () =>
      import('./pages/wallet/wallet/wallet.component').then(
        (m) => m.WalletComponent
      ),
    canActivate: [AuthGuardService],
    data: {
      ns: '/transaction-listing',
      action: 'topup', 
    },
  },

  {
    path: 'transaction-listing',
    loadComponent: () =>
      import(
        './pages/transaction/transaction-listing/transaction-listing.component'
      ).then((m) => m.TransactionListingComponent),
    canActivate: [AuthGuardService],
    data: { ns: '/transaction-listing' }, 
  },

  {
    path: 'invoice-listing',
    loadComponent: () =>
      import(
        './pages/transaction-invoice/listing/transaction-invoice-listing/transaction-invoice-listing.component'
      ).then((m) => m.TransactionInvoiceListingComponent),
    canActivate: [AuthGuardService],
    data: { ns: '/invoice-listing' }, 
  },

  {
    path: 'invoice-listing',
    loadComponent: () =>
      import(
        './pages/transaction-invoice/listing/transaction-invoice-listing/transaction-invoice-listing.component'
      ).then((m) => m.TransactionInvoiceListingComponent),
    canActivate: [AuthGuardService],
    data: { ns: '/invoice-listing' }, 
  },

  {
    path: 'invoice-details/:id',
    loadComponent: () =>
      import(
        './pages/transaction-invoice/transaction-invoice-details/transaction-invoice-details.component'
      ).then((m) => m.TransactionInvoiceDetailsComponent),
    canActivate: [AuthGuardService],
    data: { ns: '/invoice-details' }, 
  },

  {
    path: 'business-manage-listing',
    loadComponent: () =>
      import(
        './pages/business-manage/business-manage-listing/business-listing.page'
      ).then((m) => m.BusinessListingPage),
    canActivate: [AuthGuardService],
    data: { ns: '/business-manage-listing' }, 
  },
  {
    path: 'business-manage-detail/:id',
    loadComponent: () =>
      import(
        './pages/business-manage/business-manage-detail/business.page'
      ).then((m) => m.BusinessPage),
    canActivate: [AuthGuardService],
    data: { ns: '/business-manage-listing' }, 
  },

  // {
  //   path: 'banner',
  //   loadComponent: () => import('./pages/banner/banner.page').then( m => m.BannerPage)
  // },
  {
    path: 'staff',
    loadComponent: () =>
      import('./pages/staff/staff.page').then((m) => m.StaffPage),
  },
  {
    path: 'accessRole-list',
    loadComponent: () =>
      import('./pages/accessRole/listing/accessRole-listing').then(
        (m) => m.AccessRoleListing
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/accessRole-list' }, // LIST
  },
  {
    path: 'accessRole/detail/:id',
    loadComponent: () =>
      import('./pages/accessRole/detail/accessRole-detail').then(
        (m) => m.AccessRoleDetail
      ),
    canActivate: [AuthGuardService],
    data: { ns: '/accessRole-list' }, // CREATE (id=0) / EDIT (id>0)
  },
  {
    path: 'user-profile-listing',
    loadComponent: () => import('./pages/userProfile/user-profile-listing/user-profile-listing.page').then( m => m.UserProfileListingPage)
  },
  {
    path: 'user-profile-details/:id',
    loadComponent: () => import('./pages/userProfile/user-profile-details/user-profile-details.page').then( m => m.UserProfileDetailsPage)
  },
  {
    path: 'interest-listing',
    loadComponent: () => import('./pages/interest/interst-listing/interest-listing.page').then( m => m.InterestListingPage)
  },
  {
    path: 'interest-details/:id',
    loadComponent: () => import('./pages/interest/interest-details/interest-details.page').then( m => m.InterestDetailsPage)
  },  {
    path: 'redeem-qr',
    loadComponent: () => import('./pages/redeem-qr/redeem-qr.page').then( m => m.RedeemQrPage)
  }

  
  


];
